import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ErrorMessage from '~/components/ErrorMessage';
import LayoutSkeleton from '~/components/LayoutSkeleton';
import { useGetUserProfileQuery } from '~/redux/api/authApiSlice';
import PageLayout from '~myAccount/components/PageLayout';
import UserEmail from '~myAccount/components/UserEmail';
import UserLogoutFromDevices from '~/modules/myAccount/components/UserLogoutFromDevices';
import UserPassword from '~/modules/myAccount/components/UserPassword';
import UserPhoneNumber from '~/modules/myAccount/components/UserPhoneNumber';
import LogoutFromDevicesModal from '~/modules/myAccount/pages/SettingAndPrivacy/LogoutFromDevicesModal';

function SettingAndPrivacy() {
  const { t } = useTranslation('app');
  const { isLoading, isSuccess } = useGetUserProfileQuery();
  const [logoutErrorMessage, setLogoutErrorMessage] = useState('');

  return (
    <PageLayout title={t('privacy')} bodyClassName="">
      {isLoading && <LayoutSkeleton />}

      {!isLoading && isSuccess && (
        <div className="flex flex-col ">
          {logoutErrorMessage && (
            <div className="mb-2x">
              <ErrorMessage message={logoutErrorMessage} />
            </div>
          )}
          <div className="pt-x pb-3x border border-gray rounded-[8px] mb-4x">
            <UserEmail />
            <UserPassword />
            <UserPhoneNumber />
          </div>
          <UserLogoutFromDevices />
        </div>
      )}
      <LogoutFromDevicesModal setLogoutErrorMessage={setLogoutErrorMessage} />
    </PageLayout>
  );
}

export default SettingAndPrivacy;
